export const LIST_CONTAINER_CLASS = 'flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto p-card';
export const CARD_GRID_CLASS =
  'grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4';
